import { ChangeDetectionStrategy, Component, HostBinding, ViewChild, forwardRef } from '@angular/core';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-sidebar',
  styleUrls: ['./sidebar.component.scss'],
  templateUrl: './sidebar.component.html',
  // forwardRef breaks the circular ES module evaluation with NotificationSidebarComponent
  imports: [forwardRef(() => NotificationSidebarComponent)],
})
export class SidebarComponent {
  @HostBinding('class.bar-closed') public barClosed: boolean;
  @ViewChild('_notificationSidebarComponent') private _notificationSidebarComponent: NotificationSidebarComponent;
  public static key = 'rightSidebar';
  public title: string;

  public constructor() {
    this.barClosed = true;
  }

  public afterClosedHandler(): void {
    this._notificationSidebarComponent.markNotificationsAsRead();
  }

  public afterOpenedHandler(): void {}
}
